import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Form } from 'semantic-ui-react'
import ParticipantsTable from '../components/participants_table';

class EditParticipantsModal extends Component {
  constructor(props){
    super(props);

    this.state = {
      participants: []
    }

  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      participants: nextProps.participants
    })
  }

  onSaveParticipants = () => {
    this.props.saveParticipants()
    this.props.onClose()
  }

  onClose = () => {
    this.props.onClose()
    this.props.resetParticipants()
  }

  updateParticipants = (participants) => {
    this.setState({
      participants: participants
    })
    this.props.updateParticipants(participants)
  }

  render() {
    const { edit_participants, save_changes } = this.props.translations
    return (
      <Modal trigger={ this.props.trigger } size={ 'tiny' } open={ this.props.shown } onClose={ () => this.onClose() } closeOnDimmerClick={false}>
        <Modal.Header>{edit_participants}</Modal.Header>
        <Modal.Content>
          <Form>
            <div className="field">
              <ParticipantsTable
                participants={this.state.participants}
                updateParticipants={this.updateParticipants}
                translations={this.props.translations}
                isAdmin={this.props.isAdmin}
                permission={this.props.permission}
              />
            </div>
          </Form>
        </Modal.Content>

        <Modal.Actions>
          { (this.props.isAdmin || this.props.permission.can_update) &&
            <Button
              color='teal'
              content={save_changes}
              fluid
              size='medium'
              className="new-plan-button"
              onClick={ () => this.onSaveParticipants() }
            />
          }
        </Modal.Actions>
        <i className="delete icon" onClick={ () => this.onClose() }></i>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditParticipantsModal)



// WEBPACK FOOTER //
// ./src/components/edit_participants_modal.js